import { render, staticRenderFns } from "./polaris-message.vue?vue&type=template&id=2e397c9f&scoped=true&"
import script from "./polaris-message.vue?vue&type=script&lang=js&"
export * from "./polaris-message.vue?vue&type=script&lang=js&"
import style0 from "./polaris-message.vue?vue&type=style&index=0&id=2e397c9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e397c9f",
  null
  
)

export default component.exports